import { View, StyleSheet, Image } from 'react-native';
import { MultiplePurchaseOption } from './MultiplePurchaseOption';
import { useStore } from 'src/contexts/StoreContext';

export enum MultiplePurchaseContainer {
  MODAL,
  BOTTOM_SHEET,
}

interface MultiplePurchaseContentProps {
  container: MultiplePurchaseContainer;
  onPressOption: () => void;
}

export const MultiplePurchaseContent = ({ container, onPressOption }: MultiplePurchaseContentProps) => {
  const { i18n } = useStore();
  const options = [
    { label: 'option-1-2', discount: 0 },
    { label: 'option-3-5', discount: 25 },
    { label: 'option-6-8', discount: 30 },
    { label: 'option-9-more', discount: 40 },
  ];

  const computedStyle = container == MultiplePurchaseContainer.MODAL ? styleDesktop : styleMobile;

  return (
    <View style={computedStyle.container}>
      <View style={computedStyle.imageContainer}>
        <Image source={require('assets/frame-wall.png')} style={style.image} />
      </View>
      <View style={computedStyle.optionsContainer}>
        {options.map((option, index) => (
          <View style={computedStyle.optionWrapper} key={index}>
            <MultiplePurchaseOption
              label={i18n.t(`modal-multiple-purchase:${option.label}`)}
              discount={option.discount}
              onPress={onPressOption}
            />
          </View>
        ))}
      </View>
    </View>
  );
};

const style = StyleSheet.create({
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 20,
  },
});

const styleDesktop = StyleSheet.create({
  optionsContainer: {
    flex: 1,
    gap: 16,
  },
  optionWrapper: {
    flex: 1,
  },
  container: {
    flexDirection: 'row',
    gap: 28,
  },
  imageContainer: {
    maxWidth: 472,
    width: '50%',
    height: 288,
    borderRadius: 20,
  },
});

const styleMobile = StyleSheet.create({
  optionsContainer: {
    gap: 8,
  },
  optionWrapper: {
    height: 60,
  },
  container: {
    flexDirection: 'column-reverse',
    paddingBottom: 17,
    gap: 16,
  },
  imageContainer: {
    width: '100%',
    aspectRatio: '328/192',
    borderRadius: 20,
  },
});
